import InputEmail, { InputEmailProps as _InputEmailProps } from './InputEmail';

export { InputEmail };
export type InputEmailProps = _InputEmailProps;
